import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { AlertController, ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { ChangeClientPage } from 'src/app/modals/change-client/change-client.page';
import { QrcodePermitPage } from 'src/app/modals/qrcode-permit/qrcode-permit.page';
import { PlatformService } from 'src/app/platform.service';
import { DataService } from 'src/app/services/data.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qrscanner',
  templateUrl: './qrscanner.page.html',
  styleUrls: ['./qrscanner.page.scss'],
})
export class QrscannerPage implements AfterViewInit,OnDestroy {
  scanActive=false
  pattern = new RegExp('^([^\.]*?)((?:\-(?:(?:([^\.\-]*)\d+)|rc|beta|test))?(?:\.(?:dev|preview|test))?)\.([a-z0-9\-]+)\.([a-z]+):?(\d+)?$');
  constructor(
    private errorHandlerSRV:ErrorHandlerService,
    private router: Router,
    private loaderService:LoaderService,
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private dataSRV:DataService,
    public platformSRV:PlatformService,
    public modalController: ModalController,
    public translateService: TranslateService,
  ) { }
  ngOnDestroy(){
    BarcodeScanner.stopScan()
  }
  ngAfterViewInit() {
   
    BarcodeScanner.prepare()
    this.scanQRCode()
  }
  async scanQRCode(){
    const allowed = await this.checkPermissions()
    if(allowed){
      this.scanActive=true
      const result = await BarcodeScanner.startScan(); 
  
      
      if (result.hasContent) {
        result.content = result.content.toLocaleLowerCase()
        
        var ConnectedToClient = new URL(this.dataSRV.apiUrl)
        var qrClient =new URL(result.content) 
        var qrClientMatchGroups = this.pattern.exec(qrClient.hostname)
        var ConnectedToClientMatchGroups = this.pattern.exec(ConnectedToClient.hostname)

        if(qrClientMatchGroups !== null && ((qrClientMatchGroups[4]=='ops-com' && qrClientMatchGroups[5]=='com') || (qrClientMatchGroups[4]=='parkadmin' && qrClientMatchGroups[5]=='com') || (qrClientMatchGroups[4]=='opscom' && qrClientMatchGroups[5]=='app'))){
          if(this.dataSRV.isProductionBuild && qrClientMatchGroups[2]!=''){
            let alert = await this.alertCtrl.create({
              header:"Warning",
              message: "This QR code is pointed to a preview environment",
              backdropDismiss:false
            ,
              buttons: [
               
                {
                  text: this.translateService.instant('keys.data.common.close') || 'Close',
                  handler: () => {
                    this.scanQRCode()
                  }
                }
              ]
            });
            alert.present();
          } else if(!this.dataSRV.isProductionBuild && qrClientMatchGroups[2]==''){
            let alert = await this.alertCtrl.create({
              header:"Warning",
              message: "This QR code is pointed to a production environment",
              backdropDismiss:false
            ,
            buttons: [
              {
                text: this.translateService.instant('keys.data.common.close') || 'Close',
                handler: () => {
                  this.scanQRCode()
                }
              }
            ]
            });
            alert.present();
          }
          else if((qrClientMatchGroups[1] == ConnectedToClientMatchGroups[1]) && (qrClientMatchGroups[2] == ConnectedToClientMatchGroups[2]) && result.content.includes("/permits/qrcode/reservation/")){
           
            this.openQRpage(result)
            
          } 
          else if((qrClientMatchGroups[1] != ConnectedToClientMatchGroups[1]) || (qrClientMatchGroups[2] != ConnectedToClientMatchGroups[2]) && result.content.includes("/permits/qrcode/reservation/")){
            var client;
          var hostname = qrClientMatchGroups[0].toLocaleLowerCase()
            if(this.dataSRV.isProductionBuild){
              this.dataSRV.getStoredData({key:environment.clientsKey}).then(async value=>{
                var storedClient
                if(value){
                  // check if client is already stored in local storage
                  storedClient = value?.clients.find(client=> ('https://'+ hostname) == client.webUrl.toLocaleLowerCase())
                  if(storedClient){
                    this.changeClientPrompt(storedClient,result,ConnectedToClientMatchGroups[1],qrClientMatchGroups[1],true)
                  } else {
                    // if client on qr code isn't stored in local cache
                    this.dataSRV.getProductionClients()
                    .subscribe({
                      next:async (response:any)=>{
                        if(response?.error==0){
                        client = response?.data.find(client=>hostname == client.webUrl.toLocaleLowerCase())
                        if(client){
                          this.changeClientPrompt(client,result,ConnectedToClientMatchGroups[1],qrClientMatchGroups[1],false)
                        }
                        else {
                          this.notOpscomAlert()
                        }
                      } else {
                        this.errorHandlerSRV.displayErrorMessage(response,true)
                      }
                    },
                    error:err=>{
                      this.errorHandlerSRV.displayErrorMessage(err,true)
                    }
                    })
                  }

                }  
                
                
                
              })
              
            } else {
              this.dataSRV.getStoredData({key:environment.clientsKey}).then(async value=>{
                var storedClient
                if(value){
                  // check if client is already stored in local storage
                  storedClient = value?.clients.find(client=> ('https://'+ hostname) == client.webUrl.toLocaleLowerCase())
                  if(storedClient){
                    this.changeClientPrompt(storedClient,result,ConnectedToClientMatchGroups[0],qrClientMatchGroups[0],true)
                  } else {
                    // if client on qr code isn't stored in local cache
                    this.dataSRV.getTestingClients().pipe(map((res:any)=>{
                      if(res?.error==0){
                        var allClients=[]
                        res?.data.forEach(client => {
                          res?.environments.forEach(environment => {
                          allClients.push({clientName:client.clientName + ' ' + environment.label,webUrl:client.gateway + environment.base})
                          });
                        })
                        res.data = allClients
                        return res
                      }
                    }))
                    .subscribe({
                      next:async (response:any)=>{
                        if(response?.error==0){
                        client = response?.data.find(client=>hostname == client.webUrl.toLocaleLowerCase())
                        if(client){
                          this.changeClientPrompt(client,result,ConnectedToClientMatchGroups[0],qrClientMatchGroups[0],false)
                        }
                        else {
                          this.notOpscomAlert()
                        }
                      } else {
                        this.errorHandlerSRV.displayErrorMessage(response,true)
                      }
                    },
                    error:err=>{
                      this.errorHandlerSRV.displayErrorMessage(err,true)
                    }
                    })
                  }

                }  
                
                
                
              })

            }
          
         
           
            
            
            
          } else {
            this.showError()
          }

        } else {
         this.notOpscomAlert()
        }
        
         
      }
    } else {
      let alert = await this.alertCtrl.create({
        header:'Camera Permission has been denied by user',
        message: "Enable camera permission from app settings to access page",
        backdropDismiss:false
      ,
        buttons: [
         
          {
            text: this.translateService.instant('keys.data.common.close') || 'Close',
            handler: () => {
              this.navCtrl.back();
            }
          }
        ]
      });
      alert.present();
    }
  
    
  
   
    BarcodeScanner.hideBackground();
   
    
  }
  async notOpscomAlert(){
    let alert = await this.alertCtrl.create({
      header:"Wrong QR code",
      message: "This is not an OPS-COM QR code",
      backdropDismiss:false
    ,
      buttons: [
       
        {
          text: this.translateService.instant('keys.data.common.retry') || 'Retry',
          handler: () => {
            this.scanQRCode()
          }
        }
      ]
    });
    alert.present();
  }
  async changeClientPrompt(client,result,connectedToClient,qrClient,isStored){
    let alert = await this.alertCtrl.create({
      message: "You are connected to " + connectedToClient + ' but the QR is pointed to ' + qrClient,
      backdropDismiss:false
    ,
      buttons: [
       
        {
          text: this.translateService.instant('keys.data.common.close') || 'Close',
          handler: () => {
            this.scanQRCode()
          }
        },
        {
          text: 'Change provider',
          handler: () => {
            
            if(this.dataSRV.isAuthenticated.value){
              this.loaderService.showLoader("logging out")
              this.dataSRV.postLogout().subscribe(()=>{
                this.loaderService.dismissLoader()
                this.changeClientFunction(client,result,isStored)
                this.router.navigateByUrl('/login')
                
              })
            } else {
              this.changeClientFunction(client,result,isStored)
            }
            
            
            
            
          }
        }
      ]
    });
    alert.present();
  }
  changeClientFunction(client,result,isStored){
    
    
    this.loaderService.showLoader(this.translateService.instant('keys.data.config.changing_provider') || 'Changing provider...') 
            this.dataSRV.getStoredData({key:environment.clientsKey}).then(value=>{
              if(value){
                
               var newArray=value.clients
               if(isStored){
                newArray.forEach(element => {
                  if(element?.url){ //cache backward compatibility
                    element['webUrl'] = element?.url
                  }
                  if(element['webUrl']==client.webUrl){
                    element['lastSelected']=true
                  } else {
                    element['lastSelected']=false
                  }
                 });
                 
                 this.dataSRV.storeData(environment.clientsKey,
                   {
                      clients:newArray
                   
                  })
               } else {
                client = { webUrl:'https://'+client?.webUrl,clientName:client?.clientName,lastSelected:true}
                newArray.forEach(element => {
                  element['lastSelected']=false
                 });
                 newArray.push(client)
                 this.dataSRV.storeData(environment.clientsKey,
                   {
                      clients:newArray
                   
                  })
               }
                  this.dataSRV.resetDisclaimers()
                  this.dataSRV.apiUrl= client.webUrl
                  this.dataSRV.settings={}
                 this.dataSRV.getDisclaimers()
                     
   this.dataSRV.getSettings().subscribe((res) => {
    
    this.dataSRV.settings = res['settings'];

    this.loaderService.dismissLoader()
    this.openQRpage(result)
  });
  this.dataSRV.getStoredData({key:environment.clientsKey}).then(value=>{
    if(value){
      for (
        var i = 0;
        i < value.clients.length;
        i++
      ){
        if(value.clients[i].lastSelected==true){
          this.dataSRV.selectedClient=value.clients[i]
         
          
        }
      }
    }
  })
                
  }})
  }
  async openQRpage(result){
    this.stopScanner()
            
    const mobileModal = await this.modalController.create({
      component: QrcodePermitPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1,
      cssClass:"modal-mobile-normal",
      componentProps:{
        id:result.content,
        fromScanner:true
      }
    })
    const tabletModal = await this.modalController.create({
      component: QrcodePermitPage,
      breakpoints: [0.5, 0.8,1],
      initialBreakpoint: 1, 
      cssClass:"modal-tablet-normal",
      componentProps:{
        id:result.content,
        fromScanner:true
      }
    })
    if(this.platformSRV.device=='mobile'){
      return await mobileModal.present();
    } else if(this.platformSRV.device=='tablet'){
      return await tabletModal.present();
    }
  }
  async showError(){
    let alert = await this.alertCtrl.create({
      header:this.translateService.instant('keys.data.permits.qr_error_header') || 'QR code error',
      message: this.translateService.instant('keys.data.permits.qr_error_message') || 'QR Code does not contain lot data',
      backdropDismiss:false
    ,
      buttons: [
       
        {
          text: this.translateService.instant('keys.data.common.retry') || 'Retry',
          handler: () => {
            this.scanQRCode()
          }
        }
      ]
    });
    alert.present();
  }
  
  
  async checkPermissions(){
    return new Promise(async(resolve,reject)=>{
      const status = await BarcodeScanner.checkPermission({ force: true });
      if(status.granted){
        resolve(true)
      } else {
        resolve(false)
      }
    })
  }
  stopScanner(){
    BarcodeScanner.stopScan()
    this.scanActive=false
    this.navCtrl.back();
  }
}
